import { RotateCcw } from "lucide-react";
import { cn } from "@weco/ui";
import { useAssistantConversation } from "../../../modules/assistant/state/AssistantConversationProvider";

/**
 * Kit Appendix E "start over" affordance. Clears today's conversation after a
 * confirm, so an accidental click can't lose the whole thread. Placed into
 * the popover header by Task 18 — this file only owns the button itself.
 */
export function StartOverButton() {
  const { messages, status, newChat } = useAssistantConversation();
  const disabled = messages.length === 0 || status === "streaming";

  const handleClick = () => {
    if (window.confirm("Clear today's conversation and start fresh?")) {
      newChat();
    }
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      disabled={disabled}
      aria-label="Start over"
      title="Start over"
      className={cn(
        // Theme tokens, not fixed slate: slate-500 on a near-black panel is
        // the same low-contrast problem in the other direction.
        "flex h-7 w-7 items-center justify-center rounded-full text-muted-foreground transition-colors",
        "hover:bg-muted hover:text-foreground disabled:opacity-40 disabled:hover:bg-transparent",
      )}
    >
      <RotateCcw className="h-4 w-4" />
    </button>
  );
}
